import SpendMapperLogo from "@/assets/logos/spendmapper"
import GravityConnectLogo from "@/assets/logos/gravity_connect"
import PrismLogo from "@/assets/logos/prism"
import AnprLogo from "@/assets/logos/anpr"
import { ReactElement } from 'react';

export interface Option {
  name: string;
  permission: string;
  description: string;
  url: string;
  logo?: ReactElement;
  font?: string;
  new?: boolean;
}

export const extraOptions: Option[] = [
  {
    name: "— CONNECT —",
    url: "https://connect.dev.starcount.net",
    description: "Build custom audiences for insights, strategy, media planning and activation powered by the market’s best consumer geobehavioural datasets, for an ID-less and futureproofed targeting solution",
    permission: "portal:connect",
  },
  {
    name: "SpendMapper",
    url: "https://spendmapper.starcount.com",
    description: "Our spend intelligence platform reveals trends and insights across brands, competitors and categories so you can understand where customers spend their time and money, and benchmark your performance",
    permission: "portal:spendmapper",
    logo: <SpendMapperLogo />,
  },
  {
    name: "GRAVITY CONNECT",
    url: "https://gravity-connect.dev.starcount.net/",
    description: "Build custom audiences for insights, strategy, media planning and activation powered by the market’s best consumer geobehavioural datasets, for an ID-less and futureproofed targeting solution",
    permission: "portal:gravity",
    logo: <GravityConnectLogo />,
  },
  {
    name: "PRISM",
    url: "https://miroma-connect.dev.starcount.net/",
    description: "Build custom audiences for insights, strategy, media planning and activation powered by the market’s best consumer geobehavioural datasets, for an ID-less and futureproofed targeting solution",
    permission: "portal:prism",
    logo: <PrismLogo />,
  },
  {
    name: "ANPR",
    url: "https://imedia.dev.starcount.net/",
    description: "Analyse the catchments of your sites to understand who is visiting, what their behaviours are and where to reach them",
    permission: "portal:anpr",
    logo: <AnprLogo />,
  },
]


